// extracted by mini-css-extract-plugin
export default {"steps":"OnboardingSteps_steps__6FKl4","active":"OnboardingSteps_active__EAW7Q","skip":"OnboardingSteps_skip__ARXzW","visible":"OnboardingSteps_visible__-4Wn2"};